<template>
  <div v-if="showFooter" class="footer">
    <div class="module-item brand" v-if="!isMobile">
      <div class="brand-content">
        <div class="logo" :class="`logo-${$store.state.locale}`">
          <img v-lazy-load v-lazy-load :data-src="logo" :alt="$t('seo.common.logoDescription')" :title="$t('common.websiteName')" height="54" :width="schoolCode === '415' ? 275 : 'auto'" loading="lazy">
        </div>
        <div v-if="$t('common.footerOtherInfo').length > 0" class="right">
          <div v-for="(otherInfo, index) in $t('common.footerOtherInfo')" :key="index" class="wasc-auth">
            <a v-if="otherInfo.link" :href="otherInfo.link" :aria-label="otherInfo.name" target="_blank">
              <img class="wasc-icon" :height="otherInfo.iconHeight" v-lazy-load :data-src="otherInfo.icon" alt="wasc-icon" loading="lazy">
            </a>
            <p v-else class="wasc-name" v-html="otherInfo.name" />
            <img class="wasc-icon" :height="otherInfo.iconHeight" :width="schoolCode === '415' ? 28 : 'auto'" v-lazy-load :data-src="otherInfo.icon" alt="wasc-icon" loading="lazy">
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isMobile" class="module-item links" :class="`module-item-${$store.state.locale}`">
      <template v-if="showDetail">
        <div class="main-container">
          <!-- 全球分支机构 -->
          <div v-if="otherSchools.length > 0" class="links-group-item global-branches">
            <div class="title">
              {{ otherSchool.title }}
            </div>
            <div class="branch-list">
              <a
                v-for="(school, index) in otherSchools"
                :key="index"
                :class="`branch-item ${school.locale === 'hk' ? 'hk-branch-item' : ''}`"
                :href="school.url"
                :target="school.target"
                rel="nofollow noopener"
              >
                <template v-if="school.onLineName[locale]">
                  <template v-if="school.locale !== 'hk'">
                    <span class="flag-icon" :class="getFlagIconClass(school)">
                      <img
                        v-lazy-load :data-src="school.onlineflag"
                        :alt="school.onLineName[locale] || school.onLineName"
                        class="flag-image"
                        loading="lazy"
                      >
                    </span>

                    <span>{{ school.onLineName[locale] || '' }}</span>
                  </template>
                </template>
              </a>
            </div>
            <template v-if="otherSchools.length > 0">
              <div class="hk-branch-item-content" v-for="(school, index) in otherSchools" :key="index + 'hk-branch-item-content'">
                <template v-if="school.locale === 'hk'">
                  <div class="china-online-item">
                    <img
                      v-lazy-load data-src="../../../../assets/web/images/footer/china-online.png"
                      alt="Think Academy china"
                      class="flag-image"
                      loading="lazy"
                    >
                    <span>Think Academy China</span>
                  </div>
                  <a class="hk-branch-item-link" :href="school.url" :target="school.target" rel="nofollow noopener">
                    <img
                      class="flag-image"
                      v-lazy-load :data-src="school.onlineflag"
                      :alt="school.onLineName[locale] || school.onLineName"
                      loading="lazy"
                    >
                    <span class="hk-branch-item-content-text-name">{{ school.onLineName[locale] || '' }}</span>
                  </a>
                </template>
              </div>
            </template>
          </div>
          <!-- About Us & Contact Us 合并列 -->
          <div class="links-group-item about-contact-combined">
            <!-- About Us 部分 -->
            <div class="about-section">
              <div class="title">
                {{ aboutUs.title }}
              </div>
              <template v-for="(item, index) in aboutUs.links">
                <a v-if="item.target" :key="index" class="hover-transition" rel="noopener" :href="item.url" :target="item.target">{{ item.name }}</a>
                <nuxt-link v-else :key="`nuxt-link-${index}`" class="hover-transition" :to="item.url" :target="item.target" rel="noopener">
                  {{ item.name }}
                </nuxt-link>
              </template>
            </div>

            <!-- Contact Us 部分 -->
            <template v-if="Object.keys(contactUsConfig).length">
              <!-- 邮箱&电话号 -->
              <template v-if="contactUsConfig.displayType == 'contact'">
                <div class="contact-section">
                  <div class="title">
                    {{ contactUsConfig.title }}
                  </div>

                  <div class="item-group">
                    <a v-if="showContactEmail && contactEmail" class="alink-with-icon hover-transition" rel="noopener" :href="`mailto:${contactEmail}`">
                      <span>{{ contactEmail }}</span>
                    </a>
                    <a v-if="contactPhone" class="alink-with-icon hover-transition" rel="noopener" :href="`tel:${contactPhone}`">
                      <span>{{ contactPhoneString || contactPhone }}</span>
                    </a>
                  </div>
                </div>
              </template>
            </template>

            <div class="us-wechat">
              <span class="wechat-text">wechat</span>
              <img v-lazy-load :data-src="qrCode || defaultqrcode" alt="us-wechat" loading="lazy">
            </div>
          </div>

          <!-- Follow Us 列 -->
          <div v-if="followsLinks.length > 0" class="links-group-item follow">
            <div class="title">
              {{ follows.title }}
            </div>
            <div class="item-group social-icons">
              <template v-for="(follow, index) in followsLinks">
                <a v-if="follow.linkType == 'link'" :key="index" class="social-link hover-transition" rel="noopener" :href="follow.link" :target="follow.target">
                  <img class="social-icon" v-lazy-load :data-src="getSocialIcon(follow.name)" :alt="follow.name">
                </a>
                <div v-else-if="follow.linkType == 'qrcode'" :key="`follow-v-else-${index}`" class="alink-with-icon has-qrcode">
                  <img class="social-icon" v-lazy-load :data-src="getSocialIcon(follow.name)" :alt="follow.name">
                  <!-- 两个二维码特殊处理 -->
                  <div v-if="follow.linkWechat" class="qrcode-wrapper hover-transition" :class="{'is-fr': follow.linkWechat}">
                    <div>
                      <img v-lazy-load :data-src="follow.link" :alt="$t('common.websiteName') + ' ' + follow.name" class="qrcode-img" width="150" loading="lazy">
                      <div v-if="follow.tipText" class="tip-text">
                        {{ follow.tipText }}
                      </div>
                    </div>
                    <div class="line" />
                    <div v-if="follow.linkWechat">
                      <img v-lazy-load :data-src="follow.linkWechat" :alt="$t('common.websiteName') + ' ' + follow.name" class="qrcode-img" width="150" loading="lazy">
                      <div v-if="follow.tipTextWechat" class="tip-text">
                        {{ follow.tipTextWechat }}
                      </div>
                    </div>
                  </div>
                  <div v-else class="qrcode-wrapper hover-transition">
                    <img v-lazy-load :data-src="follow.link" :alt="$t('common.websiteName') + ' ' + follow.name" class="qrcode-img" width="150" loading="lazy">
                    <div v-if="follow.tipText" class="tip-text">
                      {{ follow.tipText }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <!-- 协议链接 -->
      <div class="policy-links">
        <template v-for="(item, index) in policyLinks">
          <a v-if="item.target" :key="index" class="copyright-alink hover-transition" :href="item.url" :target="item.target">{{ item.name }}</a>
          <nuxt-link v-else :key="`policy-link-else-${index}`" class="copyright-alink hover-transition" :to="item.url">
            {{ item.name }}
          </nuxt-link>
        </template>
      </div>
    </div>
    <div v-if="!isMobile" class="module-item company-info">
      <div v-for="(companyInfoItem, companyInfoIndex) in companyInfo" :key="`companyInfoIndex-${companyInfoIndex}`" class="company-info-item">
        <template v-if="!companyInfoItem.isLink">
          <p>{{ companyInfoItem.text }}</p>
        </template>
        <template v-else>
          <a class="host-record-alink hover-transition" :href="companyInfoItem.link" target="_blank" rel="noopener">{{ companyInfoItem.text }}</a>
        </template>
      </div>
    </div>
    <div v-if="isMobile" class="wrapper-touch">
      <div class="module-item brand" style="overflow: hidden;">
        <div class="logo" :class="`logo-${$store.state.locale}`">
          <img v-lazy-load :data-src="logo" :alt="$t('seo.common.logoDescription')" :title="$t('common.websiteName')" loading="lazy">
        </div>
        <div v-if="$t('common.footerOtherInfo').length > 0" class="other-info">
          <div v-for="(otherInfo, index) in $t('common.footerOtherInfo')" :key="index" class="wasc-auth">
            <a v-if="otherInfo.link" :href="otherInfo.link" target="_blank">
              <img class="wasc-icon" :height="otherInfo.iconHeight" v-lazy-load :data-src="otherInfo.icon" alt="wasc-icon" loading="lazy">
            </a>
            <p v-else class="wasc-name" v-html="otherInfo.name" />
            <img class="wasc-icon" :height="otherInfo.iconHeight" v-lazy-load :data-src="otherInfo.icon" alt="wasc-icon" loading="lazy">
          </div>
        </div>
      </div>
      <template v-if="showDetail">
        <div class="module-item links">
          <!-- 全球分支机构 -->
          <div v-if="otherSchools.length > 0" class="links-group-item global-branches">
            <div class="title" @click="toggleSection('globalBranches')">
              {{ otherSchool.title }}
              <i class="iconfont icon-arrow-down" :class="{ 'is-expanded': expandedSections.globalBranches }" />
            </div>
            <div v-show="expandedSections.globalBranches" class="branch-list">
              <a
                v-for="(school, index) in otherSchools"
                :key="index"
                :class="`branch-item ${school.locale === 'hk' ? 'hk-branch-item' : ''}`"
                :href="school.url"
                :target="school.target"
                rel="nofollow noopener"
              >
                <template v-if="school.onLineName[locale]">
                  <template v-if="school.locale !== 'hk'">
                    <span class="flag-icon" :class="getFlagIconClass(school)">
                      <img
                        v-lazy-load :data-src="school.onlineflag"
                        :alt="school.onLineName[locale] || school.onLineName"
                        class="flag-image"
                        loading="lazy"
                      >
                    </span>
                    <span>{{ school.onLineName[locale] || '' }}</span>
                  </template>
                  <template v-else>
                    <div class="hk-branch-item-content">
                      <div class="china-online-item">
                        <img
                          v-lazy-load data-src="../../../../assets/web/images/footer/china-online.png"
                          alt="Think Academy china"
                          class="flag-image"
                          loading="lazy"
                        >
                        <span>Think Academy China</span>
                      </div>
                      <a class="hk-branch-item-link" :href="school.url" :target="school.target" rel="nofollow noopener">
                        <img
                          class="flag-image"
                          v-lazy-load :data-src="school.onlineflag"
                          :alt="school.onLineName[locale] || school.onLineName"
                          loading="lazy"
                        >
                        <span class="hk-branch-item-content-text-name">{{ school.onLineName[locale] || '' }}</span>
                      </a>
                    </div>
                  </template>
                </template>
              </a>
            </div>
          </div>

          <!-- About Us -->
          <div class="links-group-item about-us">
            <div class="title" @click="toggleSection('aboutUs')">
              {{ aboutUs.title }}
              <i class="iconfont icon-arrow-down" :class="{ 'is-expanded': expandedSections.aboutUs }" />
            </div>
            <div v-show="expandedSections.aboutUs" class="item-group">
              <template v-for="(item, index) in aboutUs.links">
                <a v-if="item.target" :key="index" class="hover-transition" rel="noopener" :href="item.url" :target="item.target">{{ item.name }}</a>
                <nuxt-link v-else :key="`nuxt-link-${index}`" class="hover-transition" :to="item.url" :target="item.target" rel="noopener">
                  {{ item.name }}
                </nuxt-link>
              </template>
            </div>
          </div>

          <!-- Contact Us -->
          <div v-if="Object.keys(contactUsConfig).length" class="links-group-item contact font-medium">
            <div class="title" @click="toggleSection('contactUs')">
              {{ contactUsConfig.title }}
              <i class="iconfont icon-arrow-down" :class="{ 'is-expanded': expandedSections.contactUs }" />
            </div>
            <div v-show="expandedSections.contactUs" class="item-group">
              <!-- 邮箱&电话号 -->
              <template v-if="contactUsConfig.displayType == 'contact'">
                <div v-if="contactList.length && locale !== 'tm'" class="contact-list">
                  <div v-for="(item, index) in contactList" :key="index" class="contact-item">
                    <div class="item-title" v-html="item.title" />
                    <div class="item-content" v-html="item.content" />
                    <div v-if="item.footer" v-html="item.footer" />
                  </div>
                </div>
                <div v-else class="contact-simple">
                  <a v-if="showContactEmail && contactEmail" class="alink-with-icon" rel="noopener" :href="`mailto:${contactEmail}`">
                    <img class="contact-icon" v-lazy-load :data-src="mail" alt="email"><span>{{ contactEmail }}</span>
                  </a>
                  <a v-if="contactPhone && locale !== 'tm'" class="alink-with-icon" rel="noopener" :href="`tel:${contactPhone}`" @click="$makeCall(contactPhone, $event)">
                    <img class="contact-icon" v-lazy-load :data-src="phone" alt="phone"><span>{{ contactPhoneString || contactPhone }}</span>
                  </a>
                </div>
              </template>
              <!-- 地址联系方式 -->
              <template v-else-if="contactUsConfig.displayType == 'address'">
                <div class="address-item-group">
                  <div v-for="(address, index) in contactUsConfig.data" :key="index" class="address-item">
                    <div class="title">
                      {{ address.title }}
                    </div>
                    <div class="desc phone">
                      <img class="contact-icon" v-lazy-load :data-src="phone" alt="phone"><span>{{ address.phone }}</span>
                    </div>
                    <div class="desc open-time">
                      <i class="iconfont icon-take-class-time-solid" /><span>{{ address.openTime }}</span>
                    </div>
                    <div class="desc address-desc">
                      <i class="iconfont icon-location-solid" /><span>{{ address.address }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 电话&工作时间 -->
              <template v-if="contactUsConfig.displayType == 'workTime'">
                <div class="work-time-group">
                  <div v-if="contactPhone" class="contact-with-icon">
                    <img class="contact-icon" v-lazy-load :data-src="phone" alt="phone"><span>{{ contactPhone }}</span>
                  </div>
                  <div v-if="workingTime" class="contact-with-icon">
                    <i class="iconfont icon-take-class-time-solid" /><span>{{ workingTime }}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- Follow Us -->
          <div v-if="followsLinks.length > 0" class="links-group-item follow">
            <div class="title">
              {{ follows.title }}
            </div>
            <div class="item-group social-icons">
              <template v-for="(follow, index) in followsLinks">
                <a v-if="follow.linkType == 'link'" :key="index" class="social-link" rel="noopener" :href="follow.link" :target="follow.target">
                  <img class="social-icon" v-lazy-load :data-src="getSocialIcon(follow.name)" :alt="follow.name">
                </a>
                <div v-else-if="follow.linkType == 'qrcode'" :key="`follow-v-else-${index}`" class="social-link">
                  <img class="social-icon" v-lazy-load :data-src="getSocialIcon(follow.name)" :alt="follow.name">
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <div class="module-item company-info">
        <!-- 协议链接 -->
        <div class="policy-links">
          <template v-for="(item, index) in policyLinks">
            <a v-if="item.target" :key="index" class="copyright-alink" :href="item.url" :target="item.target">{{ item.name }}</a>
            <nuxt-link v-else :key="`policy-link-else-${index}`" class="copyright-alink" :to="item.url">
              {{ item.name }}
            </nuxt-link>
          </template>
        </div>
        <div v-for="(companyInfoItem, companyInfoIndex) in companyInfo" :key="`companyInfoIndex-${companyInfoIndex}`" class="company-info-item">
          <template v-if="!companyInfoItem.isLink">
            <p>
              {{ companyInfoItem.text }}
            </p>
          </template>
          <template v-else>
            <a class="host-record-alink hover-transition" :href="companyInfoItem.link" target="_blank" rel="noopener">{{ companyInfoItem.text }}</a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin.js';

const facebook = require('assets/images/footer/facebook.png');
const instagram = require('assets/images/footer/instagram.png');
const youtube = require('assets/images/footer/youtube.png');
// const twitter = require('assets/images/footer/facebook.png');
const linkedin = require('assets/images/footer/linkedin.png');
// const tiktok = require('assets/images/footer/facebook.png');
const wechat = require('assets/images/footer/wechat.png');
const whatsapp = require('assets/images/footer/whatsapp.png');

const mail = require('assets/images/footer/mail.png');
const phone = require('assets/images/footer/phone.png');
const logo = require('assets/images/footer/us-online-logo.png');
const defaultqrcode = require('assets/images/common/qrcode-us.png');

export default {
  mixins: [mixin],
  data() {
    return {
      logo,
      mail,
      phone,
      isMobile: false,
      expandedSections: {
        globalBranches: false,
        aboutUs: false,
        contactUs: false,
      },
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    // 切换展开/收起状态
    toggleSection(sectionName) {
      this.expandedSections[sectionName] = !this.expandedSections[sectionName];
    },

    checkScreenSize() {
      this.isMobile = window.innerWidth <= 900;
    },
    // 获取旗帜图标CSS类
    getFlagIconClass() {
      return ''
    },

    // 获取社交媒体图标
    getSocialIcon(iconName) {
      const socialIcons = {
        Youtube: youtube,
        Facebook: facebook,
        WeChat: wechat,
        WhatsApp: whatsapp,
        Instagram: instagram,
        LinkedIn: linkedin,
        // 'icon-instagram2': instagram,
        // 'icon-twitter2': twitter,
        // 'icon-linkedin2': linkedin,
        // 'icon-tiktok2': tiktok,
      }
      return socialIcons[iconName] || ''
    },

    // 处理图片加载错误
    // handleImageError(event) {
    //   // 当图片加载失败时，使用默认图片
    //   event.target.src = '/images/footer/uk.png'
    // }
  },
}
</script>
<style lang="scss" scoped>
.footer {
  background: #000000D9;

  i,
  span {
    vertical-align: middle;
  }

  a {
    display: block;
    text-decoration: none;
    font-family: Poppins;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 16px;
    letter-spacing: 0%;
    color: #fff;
  }

  .alink-with-icon {
    display: flex;
    align-items: center;
  }

  .social-icons {
    display: flex;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
    justify-content: flex-start;

    .social-link {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      transition: all 0.3s ease;
      margin: 0;

      &:hover {
        transform: translateY(-2px);
      }

      .social-icon {
        width: 28px;
        height: 28px;
        object-fit: contain;
      }
    }

    .alink-with-icon {
      .social-icon {
        width: 28px;
        height: 28px;
        object-fit: contain;
      }
    }
  }

  .module-item.brand {
    height: 108px;
    border-bottom: 1px solid #FFFFFF1A;
    .brand-content {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 1014px;
      margin: 0 auto;
      padding-right: 14px;
    }
    .logo {
      img {
        height: 32px;
        width: auto;
      }
    }

    .right {
      display: flex;
      align-items: center;

      .wasc-auth {
        display: flex;
        align-items: center;

        a {
          margin: 0;
        }

        .wasc-icon {
          display: block;
          height: 32px;
          width: 32px;
        }

        .wasc-name {
          font-family: 'Poppins';
          font-weight: 700;
          color: #fff;
          line-height: 24px;
          margin-right: 13px;
        }
      }
    }
  }

  .module-item.links {
    // padding: 40px 0;
    padding: 60px 0 12px;

    .main-container {
      max-width: 1014px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      // grid-template-columns: 2fr 1fr 1fr;
      // gap: 40px;
      margin: 0 auto;
    }

    .links-group-item {
      .title {
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 18px;
        leading-trim: NONE;
        line-height: 24px;
        letter-spacing: 0%;
        color: #fff;
        margin-bottom: 24px;
      }

      &.global-branches {
        .branch-list {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 23px 40px;
          align-items: start;
        }

        .branch-item {
          display: flex;
          align-items: flex-start;
          margin: 0;
          padding: 0;
          text-decoration: none;
          font-family: Poppins;
          font-weight: 400;
          font-style: Regular;
          font-size: 13px;
          leading-trim: NONE;
          letter-spacing: 0%;
          color: #fff;
          line-height: 16px;

          &:hover {
            text-decoration: underline;
            text-decoration-style: solid;
            text-decoration-offset: 25%;
            text-decoration-thickness: 10%;
            text-decoration-skip-ink: auto;
          }

          .flag-icon {
            margin-right: 8px;
            width: 25px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            display: inline-block;
            flex-shrink: 0;

            .flag-image {
              width: 25px;
              height: 100%;
              object-fit: contain;
              border-radius: 2px;
            }

            &.mathink {
              width: 16px;
              height: 16px;
              background: #ff6b35;
              color: #fff;
              border-radius: 2px;
              font-size: 10px;
              font-weight: bold;
              text-align: center;
              line-height: 16px;

              .flag-image {
                display: none;
              }
            }

            &.betterme {
              width: 16px;
              height: 16px;
              background: #8b5cf6;
              color: #fff;
              border-radius: 2px;
              font-size: 10px;
              font-weight: bold;
              text-align: center;
              line-height: 16px;

              .flag-image {
                display: none;
              }
            }
          }
        }

        .hk-branch-item-content {
          display: flex;
          flex-direction: column;

          .china-online-item {
            margin-top: 23px;
            width: 233px;
            border-top: 1px dashed #FFFFFF1A;
            padding-top: 16px;
            display: flex;
            align-items: center;
            .flag-image {
              width: 25px;
              height: 16px;
              object-fit: contain;
              border-radius: 2px;
            }
            span {
              margin-left: 11px;
              font-family: Poppins;
              font-weight: 400;
              font-style: Regular;
              font-size: 14px;
              leading-trim: NONE;
              line-height: 100%;
              letter-spacing: 0%;
              color: #FFFFFF99;
            }
          }

          .hk-branch-item-link {
            margin-top: 15px;
            display: flex;
            align-items: center;
            display: flex;
            align-items: center;
            padding-left: 14px;
            cursor: pointer;
            .flag-image {
              width: 25px;
              height: 16px;
              object-fit: contain;
              border-radius: 2px;
            }
            .hk-branch-item-content-text-name {
              margin-left: 11px;
              font-family: Poppins;
              font-weight: 400;
              font-style: Regular;
              font-size: 13px;
              leading-trim: NONE;
              line-height: 100%;
              letter-spacing: 0%;
              color: #FFF;
            }
            &:hover {
              .hk-branch-item-content-text-name {
                text-decoration: underline;
                text-decoration-style: solid;
                text-decoration-offset: 25%;
                text-decoration-thickness: 10%;
                text-decoration-skip-ink: auto;
              }
            }
          }
        }
      }

      &.about-contact-combined {
        .about-section {
          margin-bottom: 40px;

          .title {
            margin-bottom: 24px;
          }

          a {
            margin-top: 23px;
            &:hover {
              text-decoration: underline;
              text-decoration-style: solid;
              text-decoration-offset: 25%;
              text-decoration-thickness: 10%;
              text-decoration-skip-ink: auto;
            }
          }
        }

        .contact-section {
          .title {
            margin-bottom: 24px;
          }

          .item-group {
            .alink-with-icon {
              margin-top: 23px;
              &:hover {
                text-decoration: underline;
                text-decoration-style: solid;
                text-decoration-offset: 25%;
                text-decoration-thickness: 10%;
                text-decoration-skip-ink: auto;
              }
            }
          }
        }

        .us-wechat {
          margin-top: 23px;
          display: flex;
          flex-direction: column;
          font-family: Poppins;
          font-weight: 400;
          font-style: Regular;
          font-size: 13px;
          leading-trim: NONE;
          line-height: 100%;
          letter-spacing: 0%;
          color: #fff;

          img {
            width: 100px;
            height: 100px;
            display: block;
            margin-top: 7px;
          }
        }
      }

      .has-qrcode {
        position: relative;
        cursor: pointer;

        .qrcode-wrapper {
          position: absolute;
          left: -190px;
          top: -70px;
          padding: 12px;
          width: 180px;
          background-color: #fff;
          border-radius: 4px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
          text-align: center;
          visibility: hidden;
          opacity: 0;

          .qrcode-img {
            display: block;
            margin: 0 auto;
            width: 150px;
            height: 150px;
            background: #f1f1f1;
          }
        }

        .is-fr {
          display: flex;
          width: auto;
          left: -345px;

          .line {
            margin-top: 26px;
            width: 1px;
            border: 1px solid #f1f1f1;
            height: 100px;
          }
        }

        .tip-text {
          margin-top: 11px;
          font-size: 12px;
          line-height: 14px;
          color: #999;
        }

        &:hover {
          .qrcode-wrapper {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
  }

  .module-item.links .policy-links {
    display: flex;
    text-decoration: underline;
    margin-top: 60px;
    padding-top: 30px;
    border-top: 1px solid #FFFFFF1A;
    justify-content: center;
    // justify-content: flex-start;

    .copyright-alink {
      margin: 0 20px 0 0; // TODO: 修改为20px
      font-family: Poppins;
      font-weight: 400;
      font-style: Regular;
      font-size: 13px;
      line-height: 100%;
      letter-spacing: 0%;
      text-decoration: underline;
      text-decoration-style: solid;
      text-decoration-offset: 0%;
      text-decoration-thickness: 0%;
      text-decoration-skip-ink: auto;
      color: #FFFFFF99;
      &:hover {
        color: #fff;
      }
    }
  }

  .module-item.company-info {
    display: flex;
    justify-content: center;
    font-family: Poppins;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #FFFFFF4D;
    padding-bottom: 30px;

    .company-info-item:only-child {
      margin: 0;
    }

    a.host-record-alink {
      margin: 0;
      color: #ccc;
    }

    a.host-record-alink:hover {
      color: #ff6b35;
    }
  }
}

@media (min-width: 901px) and (max-width: 1014px) {
  .footer {
    .module-item.brand {
      .brand-content {
        max-width: 900px;
        padding-right: 0;
      }
    }
    .footer .module-item.links .links-group-item.global-branches .branch-list {
      gap: 23px 24px;
    }

    .links-group-item.follow {
      margin-left: -17px;
    }
    .module-item.links {
      .main-container {
        max-width: 900px;
      }
    }
  }
}

@media (max-width: 900px) {
  .footer {
    background: #000000D9;

    .wrapper-touch {
      padding: 0;
      width: 100%;
      .module-item {
        &:not(:last-child) {
          border-bottom: 0.267vw solid #FFFFFF1A;
        }
      }

      i,
      span {
        vertical-align: middle;
      }

      a {
        display: block;
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 3.733vw;
        leading-trim: NONE;
        line-height: 8.053vw;
        letter-spacing: 0%;
        color: #fff;
      }

      .alink-with-icon {
        .iconfont {
          margin-right: 1.6vw;
          font-size: 5.333vw;
          line-height: 5.333vw;
          text-align: center;
          color: inherit;
        }

        .contact-icon {
          margin-right: 1.6vw;
          width: 5.333vw;
          height: 5.333vw;
          object-fit: contain;
        }
      }

      .contact-simple a {
        display: flex;
        align-items: center;
      }

      .contact-with-icon {
        margin: 5.333vw 0;

        .iconfont {
          margin-right: 1.6vw;
          font-size: 5.333vw;
          line-height: 5.333vw;
          text-align: center;
          color: inherit;
        }

        .contact-icon {
          margin-right: 1.6vw;
          width: 5.333vw;
          height: 5.333vw;
          object-fit: contain;
        }
      }

      .module-item.brand {
        // padding: 22.667vw 0 11.733vw;
        padding: 5.333vw 5.333vw 3.733vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        background: #000000D9;

        .logo {

          img {
            display: block;
            width: 32.8vw;
            height: 5.333vw;
          }
        }

        .other-info {
          margin: 3.2vw 0 0;
          .wasc-auth {
            display: flex;
            align-items: center;

            a {
              margin: 0;
            }

            .wasc-icon {
              display: block;
              width: 8.533vw;
              height: 8.533vw;
            }

            .wasc-name {
              font-family: Poppins;
              font-weight: 400;
              font-style: Regular;
              font-size: 3.733vw;
              line-height: 5.333vw;
              letter-spacing: 0%;
              text-transform: uppercase;
              margin-right: 10.667vw;
              color: #fff;
            }
          }
        }
      }

      .module-item.links {
        padding: 0;
        .title {
          padding: 5.333vw 5.867vw 5.333vw 5.333vw;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          user-select: none;
          font-family: Poppins;
          font-weight: 700;
          font-style: Bold;
          font-size: 3.733vw;
          leading-trim: NONE;
          line-height: 5.333vw;
          letter-spacing: 0%;
          color: #fff;
          border-bottom: 0.267vw solid #FFFFFF1A;
          background: #000000D9;
          margin: 0;

          .iconfont {
            font-size: 4.267vw;
            transition: transform 0.3s ease;
            background-image: url('~assets/images/footer/online-arrow.png');
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center;
            width: 5.333vw;
            height: 5.333vw;

            &.is-expanded {
              transform: rotate(180deg);
            }
          }
        }

        .links-group-item.global-branches {
          .branch-list {
            display: flex;
            flex-direction: column;
            padding: 5.333vw;
            // background: #000000CC;
            gap: 0;
          }

          .branch-item {
            display: flex;
            align-items: center;
            margin: 0;
            padding: 0;
            text-decoration: none;
            font-family: Poppins;
            font-weight: 700;
            font-style: Bold;
            font-size: 3.733vw;
            leading-trim: NONE;
            line-height: 8.053vw;
            letter-spacing: 0%;

            .flag-icon {
              margin-right: 3.467vw;
              width: 6.133vw;
              height: 4.267vw;
              line-height: 4.267vw;
              text-align: center;
              display: inline-block;
              justify-content: center;
              align-items: center;
              flex-shrink: 0;

              .flag-image {
                width: 6.133vw;
                height: 4.267vw;
                object-fit: contain;
                border-radius: 0.533vw;
              }
            }
          }

          .branch-item + .branch-item {
            margin-top: 5.333vw;
          }
        }

        .hk-branch-item {
          width: 100%;
          margin-top: 2.667vw !important;
          .hk-branch-item-content {
            width: 100%;
            display: flex;
            flex-direction: column;

            .china-online-item {
              width: 100%;
              border-top: 0.267vw dashed #FFFFFF1A;
              padding-top: 2.667vw;
              display: flex;
              align-items: center;
              margin: 0;
              .flag-image {
                width: 6.133vw;
                height: 4.267vw;
                object-fit: contain;
                border-radius: 0.533vw;
              }
              span {
                margin-left: 3.467vw;
                font-family: Poppins;
                font-weight: 400;
                font-style: Regular;
                font-size: 3.733vw;
                leading-trim: NONE;
                line-height: 8.053vw;
                letter-spacing: 0%;
                color: #FFFFFF99;
              }
            }

            .hk-branch-item-link {
              display: flex;
              align-items: center;
              display: flex;
              align-items: center;
              padding-left: 3.733vw;
              cursor: pointer;
              .flag-image {
                width: 6.667vw;
                height: 4.267vw;
                object-fit: contain;
                border-radius: 0.533vw;
              }
              .hk-branch-item-content-text-name {
                margin-left: 3.2vw;
                font-family: Poppins;
                font-weight: 700;
                font-style: Bold;
                font-size: 3.733vw;
                leading-trim: NONE;
                line-height: 8.053vw;
                letter-spacing: 0%;
                color: #FFF;
              }
            }
          }
        }

        .links-group-item.about-us {
          .item-group {
            padding: 5.333vw;
            .hover-transition + .hover-transition {
              margin-top: 5.33333vw;
            }
          }
        }

        .links-group-item.contact {
          .item-group {
              padding: 5.333vw;
              .alink-with-icon + .alink-with-icon {
                margin-top: 5.33333vw;
              }
          }
        }

        .links-group-item.follow {
          background: #000000D9;
          padding: 5.333vw;
          .title {
            padding: 0;
          }

          .social-icons {
            margin-top: 3.2vw;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 7.2vw;

            .social-link {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              transition: all 0.3s ease;

              .social-icon {
                width: 8.533vw;
                height: 8.533vw;
                object-fit: contain;
              }
            }
          }
        }
      }

      .module-item.company-info {
        padding: 8vw 5.333vw;
        background: #000000D9;
        ffont-family: Helvetica;
        font-weight: 400;
        font-style: Regular;
        font-size: 3.733vw;
        leading-trim: NONE;
        line-height: 6.4vw;
        letter-spacing: 0%;
        color: #FFFFFF;
        display: flex;
        flex-direction: column;

        .company-info-item {
          margin: 3.2vw 0;
          text-align: center;

          &:last-child {
            margin: 3.2vw 0 0;
          }

          p {
            margin: 0;
            word-spacing: 0;
            letter-spacing: -0.107vw;
            font-size: 3.2vw;
          }
        }

        a.host-record-alink {
          text-align: center;
        }

        .policy-links {
          display: flex;
          flex-wrap: wrap;
          text-decoration: underline;
          gap: 5.333vw;

          .copyright-alink {
            font-family: Helvetica;
            font-weight: 400;
            font-style: Regular;
            font-size: 3.733vw;
            leading-trim: NONE;
            line-height: 6.4vw;
            letter-spacing: 0%;
            text-decoration: underline;
            text-decoration-style: solid;
            text-decoration-offset: 0%;
            text-decoration-thickness: 0%;
            text-decoration-skip-ink: auto;
            color: #FFFFFF;
            flex-wrap: nowrap;
          }
        }
      }
    }
  }
  .global-branches {
    .branch-list {
      span {
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 3.733vw;
        leading-trim: NONE;
        line-height: 8.053vw;
        letter-spacing: 0%;

      }
    }
  }

  .policy-links {
    a {
      line-height: 12vw;
      margin-bottom: 0;
    }
  }
}
</style>
